import { resolveSnowOptionsFromSKU as resolveOptionsFromSKU } from './shared.mjs'
import strap from './shared-straps.mjs'

import { lens, frame } from './ullrs.mjs'

function resolveOptions(customisedProduct) {
  const getSKUWithoutPrefix = (sku) => sku?.split('_')?.slice(1)?.join('_')

  const choice = Object.values(customisedProduct?.choices ?? {})[0]

  return {
    frame: choice?.partType === 'frame' ? getSKUWithoutPrefix(choice.sku) : 'none',

    lens: choice?.partType === 'lenses' ? getSKUWithoutPrefix(choice.sku) : 'none',

    strap: choice?.partType === 'strap' ? getSKUWithoutPrefix(choice.sku) : 'none',
  }
}

export default {
  layers: [strap, frame, lens],
  resolveOptions,
  resolveOptionsFromSKU,
}
